import axios from '../../axios-config'
/**
 * GET
 * /score/api/v1/version
 * getVersionId
 */
export const getVersionId = () => {
  return axios.get('/score/api/v1/version')
}
